










































import Vue from 'vue'
import { DefinitiveWarrantyRefundDto } from '@/Application/Expediente'

export default Vue.extend({
  name: 'DefinitiveWarrantyRefund',
  props: {
    definitivo: {
      type: DefinitiveWarrantyRefundDto || null,
      required: false
    }
  },
  computed: {
    hasRestriction (): boolean {
      return this.definitivo !== null && this.definitivo.tipoDevolucion === 'Vía de Constrinximento'
    },
    isPartial (): boolean {
      return this.definitivo !== null && this.definitivo.tipoDevolucion === 'Parcial'
    },
    importeLabel (): string {
      return this.isPartial
        ? this.$t('expediente.accountingTab.importeDevolucionParcial').toString()
        : this.$t('expediente.accountingTab.importeDevolucion').toString()
    },
    dataLabel (): string {
      return this.isPartial
        ? this.$t('expediente.accountingTab.dataDevolucionParcial').toString()
        : this.$t('expediente.accountingTab.dataDevolucion').toString()
    },
    restrictionLabel (): string {
      if (this.definitivo === null) {
        return ''
      }
      return this.$t('expediente.accountingTab.refundCauses.' + this.definitivo.restrictionCause).toString()
    },
    refundCauseLabel (): string {
      if (this.definitivo === null) {
        return ''
      }
      return this.$t('expediente.accountingTab.refundCauses.' + this.definitivo.refundCause).toString()
    }
  }
})
